import React from 'react';
import TestimonialCard from './homepage-testimonials-card.component';
import { TestimonialsArray } from './data';

import {
  TestimonialCardsContainer,
  TestimonialContainer,
  TestimonialTitle,
  TestimonialTitleWrapper,
} from './homepage-testimonials.styles';
const Testimonials = () => {
  return (
    <>
      <TestimonialContainer id='testimonials'>
        <TestimonialTitleWrapper>
          {/* <TestimonialTitle>STUDENT STORIES</TestimonialTitle> */}
          <TestimonialTitle>MEET OUR TEAM</TestimonialTitle>
        </TestimonialTitleWrapper>
        <TestimonialCardsContainer>
          {TestimonialsArray.map((testimonial) => {
            return <TestimonialCard {...testimonial} />;
          })}
          {/* <TestimonialCard />
          <TestimonialCard />
          <TestimonialCard />
          <TestimonialCard /> */}
        </TestimonialCardsContainer>
      </TestimonialContainer>
    </>
  );
};

export default Testimonials;
